<template>
  <div v-if="!isLdapUser" id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
    <!-- begin:: Content -->

    <div id="kt_subheader" class="kt-subheader kt-margin-t-0 kt-grid__item">
      <!-- begin:: Header -->
      <div class="kt-container  kt-container--fluid ">
        <div class="kt-subheader__main">
          <h3 class="kt-subheader__title">
            Password
          </h3>
          <span class="kt-subheader__separator kt-subheader__separator--v" />
          <div id="kt_subheader_search" class="kt-subheader__group">
            <span id="kt_subheader_total" class="kt-subheader__desc">
              Change your password
            </span>
          </div>
        </div>
      </div>
      <!-- end:: Header -->
    </div>

    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
      <div class="kt-portlet">
        <div class="kt-portlet__body">
          <ValidationObserver v-slot="{ invalid, handleSubmit, reset }">
            <form @submit.prevent="handleSubmit(onSubmit)" @reset="reset">
              <div class="kt-form kt-form--label-right">
                <div class="kt-form__body">
                  <div class="kt-section kt-section--first">
                    <div class="kt-section__body">
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">Current Password</label>
                        <div class="col-lg-9 col-xl-6">
                          <ValidationProvider v-slot="{ errors }" name="'Current password'" rules="required">
                            <input
                              v-model="currentPassword"
                              type="password"
                              class="form-control"
                              placeholder="Current password"
                              @input="trackCustomEvent({ event: 'input', action: 'type', target: 'input_box_content'})"
                            >
                            <span class="form-text text-muted">You must provide your current password in order to change it.</span>
                            <span style="color: red">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-xl-3 col-lg-3 col-form-label">New Password</label>
                        <div class="col-lg-9 col-xl-6">
                          <ValidationProvider v-slot="{ errors }" name="'New Password'" rules="required" vid="passwordConfirmation">
                            <input
                              v-model="newPassword"
                              type="password"
                              class="form-control"
                              placeholder="New password"
                              @input="trackCustomEvent({ event: 'input', action: 'type', target: 'input_box_content'})"
                            >
                            <span style="color: red">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="form-group form-group-last row">
                        <label class="col-xl-3 col-lg-3 col-form-label">Verify Password</label>
                        <div class="col-lg-9 col-xl-6">
                          <ValidationProvider v-slot="{ errors }" name="'Verify Password'" rules="required|confirmed:passwordConfirmation">
                            <input
                              v-model="confirmPassword"
                              type="password"
                              class="form-control"
                              placeholder="Confirm password"
                              @input="trackCustomEvent({ event: 'input', action: 'type', target: 'input_box_content'})"
                            >
                            <span style="color: red">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="kt-separator kt-separator--space-lg kt-separator--fit kt-separator--border-solid" />

                <!-- begin:: Submit & reset section -->
                <div class="kt-form__actions">
                  <div class="row">
                    <div class="col-xl-3" />
                    <div class="col-lg-9 col-xl-6">
                      <button
                        type="submit"
                        :disabled="invalid"
                        class="btn btn-brand mr-2"
                        :class="{ 'kt-spinner kt-spinner--sm kt-spinner--light': isWaitResponse }"
                        @click="trackCustomEvent({ action: 'clicked', target: 'save_changes_content'})"
                      >
                        Save changes
                      </button>
                      <button
                        type="reset"
                        class="btn btn-clean"
                        @click="trackCustomEvent({ action: 'clicked', target: 'reset_content'}); onReset()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <!-- end:: Submit & reset section -->
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
      <!--end:: userProfile component-->
    </div>

    <!-- end:: Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'

export default {
  name: 'App',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
      isWaitResponse: false
    }
  },
  computed: {
    ...mapGetters({
      getUserId: 'user/getUserId',
      getEmail: 'user/getEmail',
      getIsLdapUser: 'user/getIsLdapUser'
    }),
    isLdapUser () {
      return this.getIsLdapUser
    }
  },
  mounted () {
    if (this.getIsLdapUser) {
      this.$router.replace({ path: '/' })
    }
  },
  methods: {
    ...mapActions({
      updatePassword: 'user/updatePassword',
      loginRequest: 'user/login',
      logoutRequest: 'user/logout',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    async onSubmit () {
      this.isWaitResponse = true
      const passwordInfo = {
        userId: this.getUserId,
        password: this.currentPassword,
        newPassword: this.newPassword
      }
      const response = await this.updatePassword(passwordInfo)
      if (response) {
        Swal.fire({
          title: 'Done !',
          text: 'Your password has been updated',
          type: 'success',
          heightAuto: false,
          onClose: async () => {
            // force re-login with new-password if failed force logout and let user re-login again
            try {
              await this.loginRequest({
                email: this.getEmail,
                password: this.newPassword
              })
            } catch (e) {
              Swal.fire({
                title: 'Please re-login !',
                text: 'Please login again with your new password',
                heightAuto: false,
                onClose: async () => {
                  await this.logoutRequest()
                  this.$router.push({ path: '/login' })
                },
                allowOutsideClick: false
              })
            }
          }
        })
      } else {
        Swal.fire({
          title: 'Error !',
          text: 'Something went wrong. Please try again',
          type: 'error',
          heightAuto: false
        })
      }
      this.isWaitResponse = false
    },
    onReset () {
      this.currentPassword = null
      this.newPassword = null
      this.confirmPassword = null
    }
  }
}
</script>
